// ToastContainer - Container for managing multiple toast notifications
// Implements US-4.1: WebSocket Infrastructure and Presence System
// Displays join/leave notifications in a stack

import React from 'react';
import { Toast, ToastType } from './Toast';

export interface ToastData {
  id: string;
  message: string;
  type?: ToastType;
  duration?: number;
}

interface ToastContainerProps {
  toasts: ToastData[];
  onRemove: (id: string) => void;
}

/**
 * TOAST CONTAINER component
 * Displays a stack of toast notifications
 * Manages multiple toasts at once
 *
 * @param toasts - Array of toast data to display
 * @param onRemove - Callback when a toast should be removed
 */
export function ToastContainer({ toasts, onRemove }: ToastContainerProps): React.JSX.Element | null {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <>
      {toasts.map((toast, index) => (
        <Toast
          key={toast.id}
          message={toast.message}
          {...(toast.type && { type: toast.type })}
          {...(toast.duration && { duration: toast.duration })}
          index={index}
          onClose={() => onRemove(toast.id)}
        />
      ))}
    </>
  );
}
